'use strict';

import EAssessmentMediaBrowserDirectiveControllerCk5 from './EAssessmentMediaBrowserDirectiveControllerCk5';

/**
 * Registers a media browser directive for CK5 editor.
 * 
 * @param {object} module - The AngularJS module to register the directive with.
 */
export default function registerEAssessmentMediaBrowserDirectiveCk5(module) {
    /**
     * Registers the 'eassessmentMediaBrowserCk5' directive.
     * 
     * @returns {object} The directive definition object.
     */
    module.directive('eassessmentMediaBrowserCk5', function() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'views/ib/cms/eassessment/eassessmentmediabrowserCk5.html',
            controller: EAssessmentMediaBrowserDirectiveControllerCk5,
            controllerAs: 'mediaBrowserCtrl',
            bindToController: true,
            scope: {
                showfilter: '=',
                standalone: '=',
                showonly: '@',
                contentobjectuuid: '@',
                currentmediauuid: '@',
                mediaBrowserPromise: '='
            }
        };
    });
}


